import styled from 'styled-components';
import { Container } from './../../styles/Common';

const Header = () => {
  return (
    <>
      <Container>
        <Wrapper>
          <Left>
            <Heading>
              <span>eComm. Simplified.</span>
            </Heading>
            <Paragraph>
              An agency that elevates your brand with world class fulfillment,
              email, and sms service.
            </Paragraph>
            <LetsWorkButtonWrapper>
              <LetsWorkButton
                href="https://calendly.com/info-ripify"
                target="_blank"
              >
                <span className="text">Book a call now</span>
              </LetsWorkButton>
            </LetsWorkButtonWrapper>
          </Left>
          <Right>
            <img
              src="/assets/images/home-page-header-laptop-image.png"
              alt="header-img"
            />
          </Right>
        </Wrapper>
      </Container>
    </>
  );
};

export default Header;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 125px;
  padding-bottom: 100px;

  @media (max-width: 1200px) {
    flex-direction: column-reverse;
    margin-top: 25px;
    padding-bottom: 50px;
  }
`;

const Left = styled.div`
  width: 615px;

  @media (max-width: 1200px) {
    width: 100%;
  }
`;

const Heading = styled.h1`
  display: flex;
  margin-bottom: 20px;
  margin: 5px 0;
  justify-content: flex-start;

  span {
    background: linear-gradient(90deg, #5ca6ed 0%, #b475f8 60%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 700;
    font-family: font-bold;
    font-size: 55px;
  }

  @media (max-width: 576px) {
    justify-content: center;
    margin: 10px auto;

    span {
      font-size: 32px;
    }
  }
`;

const Paragraph = styled.p`
  font-weight: 500;
  font-size: 18px;
  font-family: font-medium;
  color: #989fb3;
  line-height: 1.8;
  margin-bottom: 10px;
  text-align: left;

  @media (max-width: 576px) {
    text-align: center;
  }
`;

const LetsWorkButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;

  @media (max-width: 576px) {
    justify-content: center;
  }
`;

const LetsWorkButton = styled.a<any>`
  margin-top: 35px;
  text-decoration: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 8;
  background: linear-gradient(
    96.91deg,
    #5ca6ed 0%,
    #5f60ef 48.46%,
    #b174f8 100%
  );
  height: 77px;
  width: 255px;
  font-family: font-medium;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  letter-spacing: 3px;

  &:after {
    position: absolute;
    content: '';
    z-index: 9;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: linear-gradient(
      96.91deg,
      #5ca6ed 0%,
      #5f60ef 48.46%,
      #b174f8 100%
    );
    transform: rotate(180deg);
    opacity: 0;
    transition: 0.3s;
  }

  .text {
    font-family: font-medium;
    font-size: 15px;
    font-weight: 500;
    color: #ffffff;
    transition: 0.3s;
    letter-spacing: 3px;
    position: relative;
    z-index: 10;
  }

  &:hover {
    &:after {
      opacity: 1;
    }
  }
`;

const Right = styled.div`
  width: calc(100% - 615px);
  display: flex;
  justify-content: flex-start;

  img {
    width: 100%;
  }

  @media (max-width: 1200px) {
    justify-content: center;
    width: 100%;

    img {
      width: 80%;
    }
  }
`;
